import AnnouncementForm from './AnnouncementForm';

export default AnnouncementForm;
